// `text.script`: live's Generate Script (#224).
// Live's script tools (the wand beside a script) build these; live lists no such row.
import { TextScriptQuote, TextScriptRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"text.script"> = {
  type: "text.script",
  label: "Script",
  source: "form",
  pair: "text.script",
  fields: (draft) => commonFields(draft),
  request: TextScriptRequest,
  quote: TextScriptQuote,
};
